import { StationsState } from '../../types';

export const resetStationsPriceReportSettings = (
  state: StationsState
) => ({
  ...state,
  stationsPriceReportSettings: {}
});
